import React from "react";
import { Box, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";

/** Shown in place of the print stages for products without customisation. */
const CustomisationNotRequiredNotice: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100%",
        minHeight: "12rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        px: 3,
        py: 4,
        borderRadius: "8px",
        border: `1px dashed ${theme.palette.customColors.purple}66`,
        backgroundColor: `${theme.palette.customColors.purple}0D`,
      }}
    >
      <InfoOutlinedIcon
        sx={{ fontSize: "2rem", color: theme.palette.customColors.purple }}
      />
      <CustomTypography variant="heading5">
        This product does not require customisation
      </CustomTypography>
      <CustomTypography
        variant="heading7"
        color={theme.palette.customColors.greyTextColor}
        style={{ maxWidth: "28rem", lineHeight: 1.5 }}
      >
        Print Outward, Print Inward and 2nd QC are not applicable. Only Raw
        Inward and 1st QC need to be completed for this product.
      </CustomTypography>
    </Box>
  );
};

export default CustomisationNotRequiredNotice;
